// DONT MOVE: Importing from project-sepcific-page-wrapper.tsx will crash AEM Build, because of gatsby related imports

export const HIDE_RESEND_MODAL = 'HIDE_RESEND_MODAL';
